module.exports = __webpack_public_path__ + "img/prestacao-servico.ba701b87.svg";